import * as React from 'react';
type Props = {
  className?: string;
};
export function FilterBadge({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-filter-badge"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1464 5.00869H21V6.88695H18.1464C17.7757 7.98122 16.7756 8.76521 15.6 8.76521C14.4244 8.76521 13.4243 7.98122 13.0536 6.88695H3V5.00869H13.0536C13.4243 3.91442 14.4244 3.13043 15.6 3.13043C16.7756 3.13043 17.7757 3.91442 18.1464 5.00869ZM16.5 5.94782C16.5 6.46648 16.0971 6.88695 15.6 6.88695C15.1029 6.88695 14.7 6.46648 14.7 5.94782C14.7 5.42915 15.1029 5.00869 15.6 5.00869C16.0971 5.00869 16.5 5.42915 16.5 5.94782ZM21 11.5826H10.9464C10.5757 10.4883 9.5756 9.70435 8.40001 9.70435C7.22441 9.70435 6.2243 10.4883 5.85364 11.5826H3V13.4609H5.85364C6.22429 14.5551 7.22441 15.3391 8.40001 15.3391C9.5756 15.3391 10.5757 14.5551 10.9464 13.4609H21V11.5826ZM8.4 13.4609C8.89706 13.4609 9.3 13.0404 9.3 12.5217C9.3 12.0031 8.89706 11.5826 8.4 11.5826C7.90294 11.5826 7.5 12.0031 7.5 12.5217C7.5 13.0404 7.90294 13.4609 8.4 13.4609ZM21 18.1565H18.1464C17.7757 17.0623 16.7756 16.2783 15.6 16.2783C14.4244 16.2783 13.4243 17.0623 13.0536 18.1565H3V20.0348H13.0537C13.4243 21.1291 14.4244 21.913 15.6 21.913C16.7756 21.913 17.7757 21.1291 18.1464 20.0348H21V18.1565ZM15.6 20.0348C16.0971 20.0348 16.5 19.6143 16.5 19.0957C16.5 18.577 16.0971 18.1565 15.6 18.1565C15.1029 18.1565 14.7 18.577 14.7 19.0957C14.7 19.6143 15.1029 20.0348 15.6 20.0348Z"
        fill="#222222"
      />
    </svg>
  );
}
